import { HistoricalCashflow } from './HistoricalCashflow.entity';

export class CashflowChart {
  constructor(
    public currentCashflow: number,
    public currentIncome: number,
    public currentExpense: number,
    public historical: HistoricalCashflow[]
  ) {}
}
